
<template>
  <div class="signup app-content bg-gray">
    <div class="bg-blue pb-5">
      <div class="container bg-blue">
        <div class="row mx-0 pb-2">
          <div class="col-12 p-0">
            <router-link :to="'./mypage'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
            </router-link>
            <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
            <router-link :to="'./threads'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.jobs_list")}}</p>
            </router-link>
          </div>
        </div>
        <div class="row pt-4 mb-2">
          <div class="col-12">
            <router-link :to="'./jobs'">
              <p class="pt-3">＜ 前に戻る</p>
            </router-link>
          </div>
        </div>
      </div>
      <div class="container px-5">

        <div class="row pt-4 mb-2 px-5">
          <div class="col-4 p-2">
          </div>
          <div class="col-8 p-2">
            <div class="row pl-250px">
              <b-img v-bind="mainProps" rounded="circle" alt="Circle image"></b-img>
              <p class="contact-name current-mail pl-2">
                  <span class="contact-description">[職種: 正]{{ jobInfo.occupation }}/{{ jobInfo.location }}</span><br/>
                  {{ companyInfo.name }}
              </p>
            </div>
          </div>
          <div class="col-12 p-3 text-center">
            <p class="app_message"> 「{{ jobInfo.title }}」の求人へ応募します。</p>
            <p class="app_message">メッセージを入力して応募を完成させてください</p>
          </div>
          <div class="col-12 px-5 py-1 text-center">
            <b-form-textarea
              v-model="message"
              placeholder="ここにメッセージを入力"
              rows="6"
            ></b-form-textarea>
            <b-button @click="sendApplication" variant="secondary" class="mt-4">この求人に申し込む</b-button>
          </div>
        </div>


        <div class="row pt-4 mb-2 px-5">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  components: {
  },
  data () {
    return {
      jobInfo: {},
      companyInfo: {},
      mainProps: { blank: true, blankColor: '#777', width: 50, height: 50, class: 'm1' },
      idToken: localStorage.idToken,
      id: this.$route.params.job_id,
      message: "",

    }
  },
  methods: {
    split(str) {
      return str.split(",")
    },
    fetch_job: function() {
      axios
      .get(process.env.VUE_APP_API + "/api/seeker/jobs/" + this.id ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.jobInfo = response.data.job
        this.companyInfo = response.data.org
      }).catch(error => {
        console.log('this is error', error)
      })
    },
    sendApplication: function() {
      this.$swal.fire({
        title: '申し込みをしますか？',
        text: "申し込みをし、企業が承認を押すとマッチングされチャットが始まります。",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '申し込む'
      }).then((result) => {
        if(result.isConfirmed) {
          var r = {
            organization_id: this.jobInfo.organization_id, 
            job_id: this.jobInfo.id,
            message: this.message
          }
          axios
            .post(process.env.VUE_APP_API + "/api/seeker/recruits", {recruit: r}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
            .then(() => {
              this.$router.push('/job_mypage')
            }).catch(error => {
              console.log('this is error', error)
            })

        }
      })
    }
  },
  async mounted() {
    if( this.memberInfo.status == 'associate_member'){
      this.$router.push('./createUser')
    }else{
      if (this.memberInfo.status == "no_deposite_member") {
        //this.$router.push('./payment')
      }
    }
    this.fetch_job()
    this.$store.commit('setLoading', false)
  },

  computed: {
    ...mapState({
        memberInfo: state => state.user.user,
        language: state => state.language
    }),
  }
}
</script>

<style scoped lang="scss">
.thread-title{
  font-size: 1.3rem;
}
.black{
  color: #000000;
}
.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}
.thread-date {
  font-size: 0.9rem;
}
.w100 {
  width: 100%;
}
.app_message {
  font-size: 22px;
}
</style>

